// extracted by css-extract-rspack-plugin
export default {"right":"DG1XV","ad":"htDFG","right_wrapper":"UWFgX","rightWrapper":"UWFgX"};